var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHomeImprovement7(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_18800_33137)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.96521 7.02441H5.96521",
    stroke: "#8A8A8A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.96521 5.52441V8.52441",
    stroke: "#8A8A8A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.96521 2.02441V18.5234",
    stroke: "#8A8A8A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.46507 2.52462L5.29407 1.41962",
    stroke: "#8A8A8A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.46521 3.02441L8.96521 2.02441",
    stroke: "#8A8A8A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.46507 11.4196L5.29407 12.5236",
    stroke: "#8A8A8A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.46509 10.9196L8.96509 11.9196",
    stroke: "#8A8A8A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5038 9.1468L21.0717 10.0684L17.9203 22.268C17.8094 22.6971 17.5327 23.0646 17.1509 23.2896C16.7691 23.5146 16.3135 23.5788 15.8845 23.4679L15.5514 23.3819C15.1223 23.2711 14.7548 22.9943 14.5298 22.6125C14.3047 22.2307 14.2406 21.7752 14.3514 21.3461L17.5028 9.14655L17.5038 9.1468Z",
    stroke: "#8A8A8A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.2019 4.78568L21.1445 5.80412C21.6224 5.92759 22.0714 6.14398 22.4657 6.44095C22.86 6.73792 23.192 7.10965 23.4427 7.53491C23.6933 7.96017 23.8578 8.43064 23.9266 8.91946C23.9954 9.40828 23.9673 9.90586 23.8439 10.3838L23.7471 10.7585L16.165 8.7999L17.2019 4.78568Z",
    stroke: "#8A8A8A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1321 3.08285L15.8407 3.00757C15.0589 2.80562 14.2615 3.27566 14.0595 4.05744L13.0626 7.91676C12.8606 8.69853 13.3307 9.496 14.1124 9.69795L14.4039 9.77323C15.1857 9.97518 15.9831 9.50514 16.1851 8.72336L17.182 4.86404C17.384 4.08227 16.9139 3.2848 16.1321 3.08285Z",
    stroke: "#8A8A8A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_18800_33137"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.96521 0.47168)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeImprovement7);
export default __webpack_public_path__ + "static/media/home-improvement-7.59e5298034b815ad95852f30597f537d.svg";
export { ForwardRef as ReactComponent };